module.exports = __webpack_public_path__ + "static/media/anonymous.37491da0.png";